<template>
  <div class="main-wrapper">
    <div class="wrapper">
      <form @submit.prevent="signIn">
        <h1>Login</h1>

        <div class="input-box">
          <input type="text" placeholder="Username" required v-model="username">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill"
            viewBox="0 0 16 16">
            <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
          </svg>
        </div>
        <div class="input-box">
          <input
            :type="showPassword ? 'text' : 'password'"
            placeholder="Password"
            required
            v-model="password"
          />
          <svg
            v-if="!showPassword"
            @click="togglePasswordVisibility"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-eye-slash-fill"
            viewBox="0 0 16 16"
          >
            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
          </svg>
          <svg
            v-else
            @click="togglePasswordVisibility"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-eye-fill"
            viewBox="0 0 16 16"
          >
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
          </svg>
        </div>
        <div class="remember-forgot">
          <label class=" text-danger">{{ errorMessage }}</label>

        </div>
        <!-- <div class="remember-forgot">
            <label><input type="checkbox">Remeber me</label>
            <router-link  to="/forgot-password">
              Forgot Password?
            </router-link>
         </div> -->

        <button type="submit" class="btn">Submit</button>
        <div class="register-link">
          <!-- <p>Don't have an account? <a href="#">
               Register
            </a></p> -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { attemptLogin } from "@/auth";
import axios from "axios";
export default {
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      showPassword: false
    };
  },
  created(){
    sessionStorage.removeItem("apiurlCr");
    sessionStorage.removeItem("apiurlu");
    sessionStorage.removeItem("lakehouseurl");
    sessionStorage.removeItem("activeSidebar");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("accessToken");
    this.fetchRegistryData()
  },
  mounted() {
    sessionStorage.removeItem("apiurlCr");
    sessionStorage.removeItem("apiurlu");
    sessionStorage.removeItem("lakehouseurl");
    sessionStorage.removeItem("activeSidebar");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("accessToken");
  },
  methods: {
    async signIn() {

      const { username, password } = this;
      attemptLogin({ username, password }, { headers: { "Content-Type": "multipart/form-data" } }).then((response) => {
        if (response.status === 200) {

        const predefinedOrder = [
        "All",
        "Dashboard",
        "Asset",
        "Hub And Sensors",
        "IoT Sensors",
        "User Mgmt.",
        "Tank Farm",
        "Remote Ops",
        "Archival"
         ];

           // Get the first matching element from predefinedOrder that exists in oanames
      const redirectTo = predefinedOrder.find(item => response.data.oanames.includes(item));

          if (redirectTo) {
              // Store the active sidebar section in sessionStorage
        sessionStorage.setItem('activeSidebar', redirectTo);
        
        switch (redirectTo) {
          case "Dashboard":
            this.$router.push('/dashboard/sensor/overview');
            break;
          case "Asset":
            this.$router.push('/iotassets/assettype');
            break;
          case "Hub And Sensors":
            this.$router.push('/hubsensors/iothub');
            break;
          case "IoT Sensors":
            this.$router.push('/iotsensors/sensortype');
            break;
          case "User Mgmt.":
            this.$router.push('/usermanagement/roletype');
            break;
          case "Tank Farm":
            this.$router.push('/tankfarm/management');
            break;
          case "Remote Ops":
            this.$router.push('/remoteops/controller');
            break;
          case "Archival":
            this.$router.push('/archival/listdata');
            break;
          case "All":
            this.$router.push('/dashboard/sensor/overview');
            break;
          default:
            this.errorMessage = "Please contact support.";
        }
      } else {
        this.errorMessage = "Please contact support.";
      }
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = "Please try again later.";
          }
        } else {
          // Handle cases where error.response is undefined
          this.errorMessage = "Please try again later.";
        }
      });
    },
    async fetchRegistryData() {
      try {
        const ipRes = await fetch('/ip.txt');
        const ip = (await ipRes.text()).trim();
        // const response = await axios.post(`http://${ip}:8004/api/iot-station/registry/app/details/get`,{appid:"AP12143235"});
        const response = await axios.post(`https://${ip}:8004/api/iot-station/registry/app/details/get`,{appid:"AP12143235"},{headers: {'Content-Type': 'application/json','Authorization': undefined}});
        this.apiurlCr = response.data.apiurlCr;
        this.apiurlu = response.data.apiurlu;
        this.lakehouseurl = response.data.lakehouseurl;
        sessionStorage.setItem('apiurlCr', JSON.stringify(this.apiurlCr)); 
        sessionStorage.setItem('apiurlu', JSON.stringify(this.apiurlu));
        sessionStorage.setItem('lakehouseurl', JSON.stringify(this.lakehouseurl)); 
      } catch (error) {
        console.error('Error fetching API data:', error);
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword; // Toggle password visibility
    }
  }

};
</script>

<style></style>